import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'content-library.field-1-name': {
    id: 'content-library.field-1-name',
    defaultMessage: 'Name',
    description:
      'The field name (and the default value/watermark) in field #1 for this database template. In this case: name'
  },
  'content-library.field-2-name': {
    id: 'content-library.field-2-name',
    defaultMessage: 'Description',
    description:
      'The field name (and the default value/watermark) in field #2 for this database template. In this case: Description'
  },
  'content-library.field-3-name': {
    id: 'content-library.field-3-name',
    defaultMessage: 'Related tags',
    description:
      'The field name (and the default value/watermark) in field #3 for this database template. In this case: Related tags'
  },
  'content-library.field-3-select-option-1': {
    id: 'content-library.field-3-select-option-1',
    defaultMessage: 'Video',
    description:
      'The option value for option #1 in field #3 for this database template. In this case: Video'
  },
  'content-library.field-3-select-option-2': {
    id: 'content-library.field-3-select-option-2',
    defaultMessage: 'Web content',
    description:
      'The option value for option #2 in field #3 for this database template. In this case: Web content'
  },
  'content-library.field-3-select-option-3': {
    id: 'content-library.field-3-select-option-3',
    defaultMessage: 'Documentation',
    description:
      'The option value for option #3 in field #3 for this database template. In this case: Documentation'
  },
  'content-library.field-3-select-option-4': {
    id: 'content-library.field-3-select-option-4',
    defaultMessage: 'Support requests',
    description:
      'The option value for option #4 in field #3 for this database template. In this case: Support requests'
  },
  'content-library.field-3-select-option-5': {
    id: 'content-library.field-3-select-option-5',
    defaultMessage: 'Blogs',
    description:
      'The option value for option #5 in field #3 for this database template. In this case: Blogs'
  },
  'content-library.field-4-name': {
    id: 'content-library.field-4-name',
    defaultMessage: 'Role',
    description:
      'The field name (and the default value/watermark) in field #4 for this database template. In this case: Role'
  },
  'content-library.field-4-select-option-1': {
    id: 'content-library.field-4-select-option-1',
    defaultMessage: 'Product',
    description:
      'The option value for option #1 in field #4 for this database template. In this case: Product'
  },
  'content-library.field-4-select-option-2': {
    id: 'content-library.field-4-select-option-2',
    defaultMessage: 'Design',
    description:
      'The option value for option #2 in field #4 for this database template. In this case: Design'
  },
  'content-library.field-4-select-option-3': {
    id: 'content-library.field-4-select-option-3',
    defaultMessage: 'Marketing',
    description:
      'The option value for option #3 in field #4 for this database template. In this case: Marketing'
  },
  'content-library.field-4-select-option-4': {
    id: 'content-library.field-4-select-option-4',
    defaultMessage: 'Engineering',
    description:
      'The option value for option #4 in field #4 for this database template. In this case: Engineering'
  },
  'content-library.field-5-name': {
    id: 'content-library.field-5-name',
    defaultMessage: 'Documentation',
    description:
      'The field name (and the default value/watermark) in field #5 for this database template. In this case: Documentation'
  },
  'content-library.field-6-name': {
    id: 'content-library.field-6-name',
    defaultMessage: 'Links',
    description:
      'The field name (and the default value/watermark) in field #6 for this database template. In this case: Links'
  },
  'content-library.field-7-name': {
    id: 'content-library.field-7-name',
    defaultMessage: 'Media',
    description:
      'The field name in field #7 for this database template. In this case: Media'
  },
  'content-library.view-1-name': {
    id: 'content-library.view-1-name',
    defaultMessage: 'All content',
    description:
      'The view name for view #1 in this template. Displayed on the top left of the screen (below the database name). In this case: All content'
  },
  'content-library.entry-1-cell-1': {
    id: 'content-library.entry-1-cell-1',
    defaultMessage: 'Documentation',
    description:
      'The text value of cell #1 in row (entry) #1 in this database template. In this case:  Documentation'
  },
  'content-library.entry-1-cell-2': {
    id: 'content-library.entry-1-cell-2',
    defaultMessage: 'Pages and topics for getting started with databases.',
    description:
      'The text value of cell #2 in row (entry) #1 in this database template. In this case:  Pages and topics for getting started with databases.'
  },
  'content-library.entry-2-cell-1': {
    id: 'content-library.entry-2-cell-1',
    defaultMessage: 'Customer videos',
    description:
      'The text value of cell #1 in row (entry) #2 in this database template. In this case:  Customer videos'
  },
  'content-library.entry-2-cell-4': {
    id: 'content-library.entry-2-cell-4',
    defaultMessage: 'Introduction video for new customers.',
    description:
      'The text value of cell #4 in row (entry) #2 in this database template. In this case:  Introduction video for new customers.'
  },
  'content-library.entry-3-cell-1': {
    id: 'content-library.entry-3-cell-1',
    defaultMessage: 'Marketing content',
    description:
      'The text value of cell #1 in row (entry) #3 in this database template. In this case:  Marketing content'
  },
  'content-library.entry-3-cell-2': {
    id: 'content-library.entry-3-cell-2',
    defaultMessage: 'Databases landing page. ',
    description:
      'The text value of cell #2 in row (entry) #3 in this database template. In this case:  Databases landing page. '
  },
  'content-library.entry-4-cell-1': {
    id: 'content-library.entry-4-cell-1',
    defaultMessage: 'Technical support',
    description:
      'The text value of cell #1 in row (entry) #4 in this database template. In this case:  Technical support'
  },
  'content-library.entry-4-cell-2': {
    id: 'content-library.entry-4-cell-2',
    defaultMessage: 'Confluence customer support.',
    description:
      'The text value of cell #2 in row (entry) #4 in this database template. In this case:  Confluence customer support.'
  },
  'content-library.entry-5-cell-1': {
    id: 'content-library.entry-5-cell-1',
    defaultMessage: 'Public forum',
    description:
      'The text value of cell #1 in row (entry) #5 in this database template. In this case:  Public forum'
  },
  'content-library.entry-5-cell-2': {
    id: 'content-library.entry-5-cell-2',
    defaultMessage:
      'Discuss databases, share feedback, report bugs, and connect with other customers.',
    description:
      'The text value of cell #2 in row (entry) #5 in this database template. In this case:  Discuss databases, share feedback, report bugs, and connect with other customers.'
  }
});
